<template>
  <div class="interaction-container">
    <div class="error-message"></div>
    <div
      class="atc-button"
      :class="{ disabled: !activeProduct.available }"
      @click="() => handleClick()"
    >
      {{ activeProduct.available ? ATC_TEXT : OUT_OF_STOCK_TEXT }}
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "CustomizerATC",
  props: {
    quantity: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      ATC_TEXT: "Add To Cart",
      OUT_OF_STOCK_TEXT: "Sold Out",
      ADD_ENDPOINT: "/cart/add.js?sections=cart-drawer,cart-icon-bubble",
      CART_ENDPOINT: "/cart",
      errorMessage: "TESTING",
    };
  },
  computed: {
    ...mapGetters({
      activeFabric: "fabrics/getActiveFabric",
      activeLeg: "legs/getActiveLeg",
      activeCushion: "cushions/getActiveCushion",
      activeOrientation: "orientations/getActiveOrientation",
      productType: "customizer/getProductType",
      activeProduct: "products/getActiveProduct",
      activeTimeline: "shipping/getActiveTimeline",
    }),
  },
  methods: {
    handleClick() {
      if (this.activeProduct.available) {
        this.errorMessage = "";
        axios
          .post(this.ADD_ENDPOINT, {
            quantity: this.quantity,
            id: this.activeProduct.id
              ? this.activeProduct.id
              : this.activeProduct.variantId,
            properties: this.derivePropertiesObject(),
          })
          .then((resp) => {
            document.dispatchEvent(new CustomEvent('cart-custom-update', {
              detail:  {
                cart: resp.data
              }
            }))
          })
          .catch((error) => {
            console.log(error);
            this.errorMessage =
              "An Unexpected Error Has Occured. Please Try Again Later.";
          });
      }
    },
    derivePropertiesObject() {
      const propObject = {};
      const otherKeys = [
        "height",
        "depth",
        "chair_base",
        "chair_size",
        "orientation",
        "bed_size",
      ];
      const hiddenKeys = [
        "depth_size"
      ]
      const productSizeMapping = {
        Chair: ["width_1", "depth_size"],
        Chaise: ["chaise_width", "chaise_length"],
        Sectional: ["width_1", "width_2"],
        Ottoman: ["width_1", "depth_size"],
        "Sectional with Bumper": ["width_1", "width_2"],
        "U-Shaped Sectional": ["width_1", "width_2"],
        "U-Shaped Double Chaise Sectional": ["width_1", "width_2"],
        "Bench Seat U-Shaped Double Chaise Sectional": ["width_1", "width_2"],
        "U-Shaped Sectional with Bumper": ["width_1", "width_2"],
        "Sofa with Chaise": ["width_1", "chaise_width", "chaise_length"],
        Sofa: ["width_1"],
      };

      if (productSizeMapping[this.productType]) {
        propObject["Size"] = this.deriveSizeProperty(
          productSizeMapping[this.productType]
        );
      }

      otherKeys.forEach((key) => {
        const productValue = this.activeProduct[key];
        if (productValue) {
          propObject[this.formatProperty(key)] = productValue;
        }
      });

      hiddenKeys.forEach((key) => {
        const productValue = this.activeProduct[key];
        if (productValue) {
          propObject["_" + this.formatProperty(key)] = productValue;
        }
      });

      if (this.activeProduct.frame_codes) {
        this.activeProduct.frame_codes
          .split("|")
          .forEach((frameCode, index) => {
            propObject[`_Frame Code ${index + 1}`] = frameCode;
          });
      }
      if (this.activeCushion) {
        propObject["Cushion"] = this.activeCushion.title;
      }
      if (this.activeLeg) {
        propObject["Leg"] = this.activeLeg.title;
      }
      if (this.activeFabric) {
        propObject["Fabric"] = this.activeFabric.title;
        propObject["_Fabric Category"] =
          this.activeFabric.fabric_options?.join(",") || '';
        propObject["_Fabric Code"] = this.activeFabric.sku_code;
      }

      if (this.activeTimeline) {
        propObject["_leadTime"] = this.activeTimeline
      }
      
      return propObject;
    },
    deriveSizeProperty(fields) {
      const fieldValues = [];
      for (const field of fields) {
        const productField = this.activeProduct[field];
        if (productField) {
          fieldValues.push(`${productField}"`);
        }
      }
      if (fieldValues.length === 1) {
        return fieldValues[0];
      }
      return fieldValues.join(" x ");
    },
    formatProperty(key) {
      let formattedKey = key
        .split("_")
        .map((part) => part[0].toUpperCase() + part.substring(1))
        .join(" ");
      switch (formattedKey) {
        case "Bed Size":
          return "Size";
        case "Fabric":
          return "Fabric Category";
        case "Orientation":
          return this.productType === "Chaise"
            ? "Facing"
            : this.productType === "Sectional"
            ? "Corner"
            : "Bumper";
      }
      return formattedKey;
    },
  },
};
</script>
<style scoped>
.error-message:not(:empty) {
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  padding: 10px 5px;
  margin-bottom: 5px;
  border-radius: 3px;
  background: var(--error-background);
  color: var(--error-foreground);
}
.atc-button {
  background: var(--button-background);
  color: var(--button-foreground);
  cursor: pointer;
  transition: .2s ease;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  margin: 20px 0;
  padding: 8px 15px;
  border-radius: 10px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  text-transform: uppercase;
}
.atc-button:not(.disabled):hover {
  opacity: var(--hover-opacity);
}
.atc-button.disabled {
  opacity: var(--disabled-button-opacity);
  cursor: not-allowed;
}
</style>
